/* eslint-disable camelcase */
import { graphql } from 'react-relay/hooks';
import Image from 'next/image';
import { useZusHomeStore } from '@/helpers/context';
import { useZusUserConnectedStore } from '@/helpers/user-auth.js';
import { ucfirst, wasUseFragment as useFragment } from '@/helpers/common';

const fragment = graphql`
  fragment avatar_user on User {
    firstname
    lastname
    logo
    avatar {
      nameId
      extension
    }
  }
`;

function Avatar({
  className, user: userRef, onClick, renderAvatar, userData, bgColor,
}) {
  const user = useFragment(fragment, userRef, {
    firstname: '', lastname: '', logo: null, avatar: null,
  });
  const userConnected = useZusUserConnectedStore((state) => state.userData);

  const { extWebpJpg: extension } = useZusHomeStore.getState();

  let newProps = {
    className,
  };
  if (onClick) {
    newProps = {
      ...newProps,
      onClick,
    };
  }

  function renderLogo() {
    if (!user?.avatar || !user?.avatar?.nameId || !user?.avatar?.extension) {
      return (
        <span className={`flex items-center justify-center h-full text-white ${bgColor || 'bg-purple-6'}`}>
          {(user?.firstname || '').trim()[0]}
        </span>
      );
    }
    const imageUrl = `${process.env.NEXT_PUBLIC_IMAGER_ENGINE}/zone/${user.avatar.nameId}-60-60-${user.avatar.extension}.${extension}`;
    return (
      <Image priority fill style={{ objectFit: 'cover' }} alt={`Avatar ${user?.firstname}`} src={imageUrl} />
    );
  }

  function renderAvatarImage() {
    if (user?.logo) {
      return <Image priority fill style={{ objectFit: 'contain' }} alt={`Logo ${user?.firstname}`} src={`${user.logo}?size=126`} />;
    } if (userConnected?.corpo?.name) {
      return <div className="flex items-center justify-center w-full h-full bg-black text-white-dark2">{(ucfirst(userConnected?.corpo?.name) || '').trim()[0]}</div>;
    }
    return null;
  }

  function renderAvatarOrCompanyLogo() {
    if (renderAvatar) {
      return renderAvatarImage();
    }
    return renderLogo();
  }

  return (
    <div {...newProps}>
      {renderAvatarOrCompanyLogo()}
    </div>
  );
}

export { Avatar };
export default Avatar;
